import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "utils/cn";

const badgeVariants = cva(
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors",
    {
        variants: {
            variant: {
                default: "border-transparent bg-primary text-primary-foreground",
                secondary: "border-transparent bg-secondary text-secondary-foreground",
                destructive: "border-transparent bg-destructive text-destructive-foreground",
                success: "border-transparent bg-[var(--success-bg-color)] text-[var(--success-color)]",
                error: "border-transparent bg-[var(--error-bg-color)] text-[var(--error-color)]",
                outline: "text-foreground",
            },
        },
        defaultVariants: { variant: "default" },
    }
);

function Badge({ className, variant, ...props }) {
    return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
